function HeroPencil() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
		>
			<path
				d='M8.66669 9.3335L6.66669 7.3335M10.0069 2.3335V1.3335M12.6331 3.37394L13.3403 2.66683M12.6331 8.66683L13.3403 9.37394M7.34026 3.37394L6.63315 2.66683M13.6736 6.00016H14.6736M4.0876 13.9126L10.2458 7.75441C10.5098 7.4904 10.6418 7.35839 10.6912 7.20617C10.7348 7.07228 10.7348 6.92805 10.6912 6.79415C10.6418 6.64193 10.5098 6.50993 10.2458 6.24592L9.75427 5.75441C9.49026 5.4904 9.35825 5.35839 9.20603 5.30893C9.07214 5.26543 8.92791 5.26543 8.79401 5.30893C8.64179 5.35839 8.50978 5.4904 8.24577 5.75441L2.0876 11.9126C1.82359 12.1766 1.69158 12.3086 1.64213 12.4608C1.59862 12.5947 1.59862 12.7389 1.64213 12.8728C1.69158 13.0251 1.82359 13.1571 2.0876 13.4211L2.57911 13.9126C2.84312 14.1766 2.97512 14.3086 3.12734 14.3581C3.26124 14.4016 3.40547 14.4016 3.53937 14.3581C3.69158 14.3086 3.82359 14.1766 4.0876 13.9126Z'
				stroke='white'
				stroke-width='1.2'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
		</svg>
	)
}

export default HeroPencil
